import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { bffApolloClient } from '../apollo/bffClient';
import { GEOLOCATION } from '../gql/getGeolocation.noncodegen.nographql';
import { CheggEnv } from '@chegg/utils';
export var getLocation = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(environment) {
    var _data$getLocationByIp, _data$getLocationByIp2, _data$getLocationByIp3, _data$getLocationByIp4, _yield$bffApolloClien, data, countryCode, region;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return bffApolloClient(environment).query({
            query: GEOLOCATION
          });
        case 3:
          _yield$bffApolloClien = _context.sent;
          data = _yield$bffApolloClien.data;
          countryCode = (_data$getLocationByIp = data === null || data === void 0 || (_data$getLocationByIp2 = data.getLocationByIp) === null || _data$getLocationByIp2 === void 0 ? void 0 : _data$getLocationByIp2.countryCode) !== null && _data$getLocationByIp !== void 0 ? _data$getLocationByIp : '';
          region = (_data$getLocationByIp3 = data === null || data === void 0 || (_data$getLocationByIp4 = data.getLocationByIp) === null || _data$getLocationByIp4 === void 0 ? void 0 : _data$getLocationByIp4.regionFull) !== null && _data$getLocationByIp3 !== void 0 ? _data$getLocationByIp3 : '';
          return _context.abrupt("return", {
            countryCode: countryCode,
            region: region
          });
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          if (environment !== CheggEnv.PROD) {
            console.error(_context.t0);
          }
          return _context.abrupt("return", {
            countryCode: '',
            region: ''
          });
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 10]]);
  }));
  return function getLocation(_x) {
    return _ref.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/utils/geoLocation.js
// module id = 2877
// module chunks = 11